import {IconButton} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import {UserCanAny} from '../UserCan';

type Props = {
  filename: string;
  url: string;
};

const DownloadButton = ({filename, url}: Props) => {
  const handleDownload = async () => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Download failed:', error);
    }
  };

  return (
    <UserCanAny scope='is-admin,staff'>
      <IconButton onClick={handleDownload}>
        <DownloadIcon />
      </IconButton>
    </UserCanAny>
  );
};

export default DownloadButton;
